"use client";

import Script from "next/script";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { selectAuthState } from "@/store/features/authSlice";

  const deploymentId = process.env.NEXT_PUBLIC_AI_ASSISTANT_DEPLOYMENT_ID;
  const orgUrl = process.env.NEXT_PUBLIC_AI_ASSISTANT_ORG_URL;
  const scriptSrc = process.env.NEXT_PUBLIC_AI_ASSISTANT_SCRIPT_SRC;

export default function AIAssistantChat() {
  const { isAuth, user } = useSelector(selectAuthState);

  useEffect(() => {
    if (!deploymentId || !orgUrl) return;
    const config = { deploymentId, orgUrl };
    if (isAuth && user) {
      if (user?.sub) config.email = user?.sub;
      if (user?.login) config.phone = user?.login;
    }
    window.AIAssistantChatConfig = config;
  }, [isAuth, user, deploymentId, orgUrl]);


  return (
    <>
      {scriptSrc && <Script
       key={`${user?.sub || "guest"}-${isAuth}`}
       src={scriptSrc} 
       strategy="afterInteractive" />}
    </>
  );
}
